<template>
  <v-card outlined class="pa-4">
    <v-card-title>
      Neues Item Anlegen
    </v-card-title>
    <v-divider class="mb-3" />
    <v-form @submit.prevent="create()">
      <v-row>
        <v-col cols="12">
          <v-text-field v-model="form.name" outlined label="Item Name" />
        </v-col>
        <v-col cols="12">
          <v-textarea v-model="form.description" outlined label="Beschreibung" />
        </v-col>
        <v-col class="d-flex justify-end" cols="12">
          <v-btn type="submit" color="primary">
            Speichern
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
export default {
   name: 'ItemCreate',
   props: {
      product: {
         type: Number,
         required: true
      }
   },
   data () {
      return {
         form: this.$inertia.form({
            name: null,
            description: null
         })
      }
   },
   methods: {
      create () {
         this.form.post(this.route('item.store', this.product))
      }
   }
}
</script>

<style></style>
